

























































































































































import { Component } from 'nuxt-property-decorator'
import { Col, DataTableHeader } from '@/components/molecules/DataTable'
import DataTable from '@/components/molecules/DataTable/DataTable.vue'
import { RecycleScroller } from '@/components/molecules/RecycleScroller'
import { uniqueId } from 'lodash'
import { IconBibliography } from '@/components/molecules/IconBibliography'
import { BibliographySearchResultsSimpleTable } from '@/components/organisms/BibliographySearchResultsSimpleTable'
import { CollectionFlag, Prefix } from '@/types'
import { systemParameterStore } from '@/utils/store-accessor'

@Component({
  components: {
    DataTable,
    DataTableHeader,
    RecycleScroller,
    IconBibliography
  }
})
export default class BibliographySearchResultsDetailTable extends BibliographySearchResultsSimpleTable {
  get checkBoxName() {
    return uniqueId('bibliography-search-results-detail-table')
  }

  get showCols(): Col[] {
    if (this.reservable) {
      return this.defaultCols
    } else {
      return this.defaultCols.filter(col => {
        return col.items[0].name !== 'reserve'
      })
    }
  }

  get defaultCols(): Col[] {
    return [
      {
        width: 26,
        items: [
          {
            name: 'check',
            align: 'center'
          }
        ]
      },
      {
        width: 60,
        items: [
          {
            name: 'no',
            align: 'right'
          }
        ]
      },
      {
        width: '8',
        resizable: true,
        items: [
          {
            name: 'displayMaterialFormat',
            headerText: '形態',
            sortable: true,
            sortOrder: ''
          },
          {
            name: 'displayClass',
            headerText: '分類',
            sortable: true,
            sortOrder: ''
          }
        ]
      },
      {
        width: '21',
        resizable: true,
        items: [
          {
            name: 'displayTitle',
            headerText: 'タイトル',
            sortable: true,
            sortOrder: ''
          },
          {
            name: 'displaySubtitle',
            headerText: systemParameterStore.searchResultDetailSubTitle,
            sortable: true,
            sortOrder: ''
          }
        ]
      },
      {
        width: '21',
        resizable: true,
        items: [
          {
            name: 'displayAuthor',
            headerText: '責任表示／年月日号',
            sortable: true,
            sortOrder: ''
          },
          {
            name: 'displayPublisher',
            headerText: '出版者',
            sortable: true,
            sortOrder: ''
          }
        ]
      },
      {
        width: '8',
        resizable: true,
        items: [
          {
            name: 'displayPublished',
            headerText: '出版年',
            sortable: true,
            sortOrder: ''
          },
          {
            name: 'displaySize',
            headerText: '大きさ'
          }
        ]
      },
      {
        width: '8',
        resizable: true,
        items: [
          {
            name: 'shelfType',
            headerText: '配架'
          },
          {
            name: 'callNo',
            headerText: '請求記号'
          }
        ]
      },
      {
        width: '8',
        resizable: true,
        items: [
          {
            name: 'status',
            headerText: '資料状況'
          },
          {
            name: 'collectionNo',
            headerText: '資料番号'
          }
        ]
      },
      {
        width: '8',
        resizable: true,
        items: [
          {
            name: 'handlingType',
            headerText: '取扱区分'
          },
          {
            name: 'collectionStatus',
            headerText: '資料状態'
          }
        ]
      },
      {
        width: '4',
        resizable: true,
        items: [
          {
            name: 'shelfCount',
            headerText: '貸可',
            align: 'right'
          }
        ]
      },
      {
        width: '4',
        resizable: true,
        items: [
          {
            name: 'holdingCount',
            headerText: '所蔵',
            align: 'right'
          }
        ]
      },
      {
        width: '4',
        resizable: true,
        items: [
          {
            name: 'orderCount',
            headerText: '発注',
            align: 'right'
          }
        ]
      },
      {
        width: '4',
        resizable: true,
        items: [
          {
            name: 'reserveCount',
            headerText: '予約',
            align: 'right'
          }
        ]
      },
      {
        width: 50,
        items: [
          {
            name: 'reserve',
            headerText: '',
            align: 'center'
          }
        ]
      }
    ]
  }

  isPrefixSet(prefix: string): boolean {
    return prefix === Prefix.Set
  }

  isCollectionFlagCollection(collectionFlag: CollectionFlag): boolean {
    return collectionFlag === CollectionFlag.Collection
  }
}
